import { DatePicker } from '@syncfusion/ej2-calendars';
import { Grid, Filter, Page, Sort, RecordClickEventArgs, Toolbar } from '@syncfusion/ej2-grids';
import { DataManager, WebApiAdaptor } from '@syncfusion/ej2-data';
import { ImportQueueStatus } from '../../Models/MailboxPdf/ImportQueueStatus';
import { SyncfusionDropdownHelper } from '../../Helpers/SyncfusionDropdownHelper';
import { DateHelper } from '../../Helpers/DateHelper';
import { SyncfusionGridHelper } from '../../Helpers/SyncfusionGridHelper';

export class ImportDataQueueManager {

    constructor(private containerElement: JQuery) { }
    
    private queueGrid : Grid;


    private isUserAdmin : boolean
    

    public initialize() {
        var self = this;

        Grid.Inject(Toolbar, Filter, Page, Sort);

        self.initializeQueueTable();
    }

    private initializeQueueTable() {
        var self = this;

        var loadingContainer = self.containerElement.find('#loading-container');
        var queueGridContainer = self.containerElement.find('#import-data-queue-container');

        var gridElement : JQuery<HTMLElement> = self.containerElement.find('#ImportDataQueueGrid');
        var gridContentElement : JQuery<HTMLElement> = gridElement;
        
        var creationDateElem : any;
        var creationDateObj;


        let data: DataManager = new DataManager({
            url: '/api/company/import/queue',
            adaptor: new WebApiAdaptor
        });

        self.queueGrid = new Grid(
            {
                height: '100%',
                dataSource: data,
                toolbarTemplate: '#toolbar-template',
                columns: [
                { field: 'CreationDateTimeString', headerText: 'Created', autoFit: true, allowEditing: false, allowFiltering: true,
                    filterBarTemplate: {
                        create: () => { 
                            creationDateElem = document.createElement('input'); 
                            return creationDateElem; 
                        }, 
                        write: (args) => {
                            const persistedValue =
                                args?.value
                                ?? self.queueGrid?.filterSettings?.columns
                                    ?.find((x: any) => x.field === 'CreationDateTimeString')
                                    ?.value;

                            creationDateObj = new DatePicker({
                                value: SyncfusionGridHelper.parseDatePickerValue(persistedValue),
                                format: 'dd-MM-yyyy',
                                floatLabelType: 'Never',

                                change: (args) => {
                                    const dateValue = DateHelper.DateToString(args.value);

                                    if (dateValue == undefined) {
                                        self.queueGrid.removeFilteredColsByField(
                                            'CreationDateTimeString'
                                        );
                                    } else {
                                        self.queueGrid.filterByColumn(
                                            'CreationDateTimeString',
                                            'equal',
                                            dateValue,
                                            undefined,
                                            true
                                        );
                                    }
                                }
                            });

                            creationDateObj.appendTo(creationDateElem);
                        } 
                    }, width: '150px', validationRules: { required: true }},
                    { field: 'UploadedBy', headerText: 'Uploader', width: 100, template: '${getCreatedByTemplate(data.CreatedBy, data.CreatedByInitials)}', allowFiltering: false },
                    { field: 'StatusText', headerText: 'Status', autoFit: true, validationRules: { required: false }, allowSorting: false, allowFiltering: true, width: '175px', filterBarTemplate: SyncfusionDropdownHelper.templateEnumOptionsDropDown(() => self.queueGrid, 'StatusText', Object.keys(ImportQueueStatus).filter(key => isNaN(Number(key))), 
                        (args) => {
                        if (args.value !== 'All') {
                            self.queueGrid.filterByColumn(args.item.parentElement.id.replace('_options', ''), 'equal', args.value, undefined, true);
                        } else {
                            self.queueGrid.removeFilteredColsByField(args.item.parentElement.id.replace('_options', ''));
                        }
                    }, 'ReadyToValidate')},
                    { field: 'DataType', headerText: 'Data type', width: 100, allowFiltering: false},
                    { field: 'Reference', headerText: 'Reference', width: 300, allowFiltering: false},
                    { field: 'ImportStartDateTimeString', headerText: 'Import start', width: 100, allowFiltering: false},
                    { field: 'ImportEndDateTimeString', headerText: 'Import end', width: 100, allowFiltering: false},
                    { field: 'ErrorMessage', headerText: 'Error', allowFiltering: false},
                    
                ],
                allowSorting: true,
                allowPaging: true,
                allowFiltering: true,
                allowSelection: false,
                enablePersistence: true,
                pageSettings: { pageSize: 50 },
                filterSettings:{
                    columns: [
                        { field: 'StatusText', value: 'ReadyToValidate', operator: 'equal' }
                    ],
                },
                created: () => {
                    gridContentElement = gridContentElement.find('.e-content')
                    loadingContainer.addClass('d-none');
                    queueGridContainer.removeClass('d-none');
                },
                actionBegin: (args) => {
                    if (!this.queueGrid) {
                        return;
                    }

                    if (SyncfusionGridHelper.isFilterAction(args)) {
                        this.queueGrid.pageSettings.currentPage = 1;
                    }
                },
                dataBound: () => {
                    gridContentElement.find('[data-bs-toggle="tooltip"]').tooltip({ container: 'body', trigger: 'hover' });
                }
            });
            
        self.queueGrid.appendTo('#ImportDataQueueGrid');

        var toolbar = self.containerElement.find('#toolbar-template');
        if(toolbar != undefined && toolbar.length > 0) {
            var clearFiltersButton = toolbar.find('#clear-filters-button');
            clearFiltersButton.off('click').on('click', () => {
                self.queueGrid.pageSettings.currentPage = 1;
                self.queueGrid.clearFiltering();
                self.queueGrid.refreshHeader();
            })
        }
    }
}